'use client'

import Link from 'next/link'
import Typography from 'src/components/design-system/Typography'
import { useTranslateEntry } from 'src/i18n/client/useTranslateEntry'
import { getEditorialPanelJournalUrl } from 'src/_helpers/adminPanelLinks'
import LogIn from 'public/icons/interface/login.svg'

// 5151:32962 — dwa wejścia do panelu redakcyjnego ze strony czasopisma. Oba
// ustawiają to czasopismo jako bieżące; „Prześlij manuskrypt” otwiera od razu
// składanie manuskryptu.
const EditorialPanelEntryButtons = ({ journal, isDomainJournal = false, className = '' }) => {
  const translate = useTranslateEntry()
  const loginUrl = getEditorialPanelJournalUrl(journal?.uuid)
  const submitUrl = getEditorialPanelJournalUrl(journal?.uuid, 'submit')

  if (!loginUrl || !journal?.editorialPanelEnabled) return null

  const textColor = isDomainJournal ? 'text-basic-black' : 'text-dark-blue-dark-blue2'

  return (
    <div className={`flex flex-col t:flex-row gap-16 ${className}`}>
      <Link
        href={loginUrl}
        target="_blank"
        rel="noopener noreferrer"
        className={`border-1 rounded-4 flex items-center justify-center gap-x-6 px-16 py-12 transition-colors cursor-pointer w-fit ${
          isDomainJournal
            ? 'border-basic-gray8 bg-basic-gray8 hover:border-basic-black hover:bg-basic-white'
            : 'bg-blueish-blueish4 border-blueish-blueish4 hover:bg-basic-white hover:border-dark-blue-dark-blue2'
        }`}
      >
        <LogIn viewBox="0 0 21 21" />
        <Typography variant="body3" component="span" color={textColor}>
          {translate('T_JOURNAL_EDITORIAL_PANEL_LOGIN')}
        </Typography>
      </Link>
      <Link
        href={submitUrl}
        target="_blank"
        rel="noopener noreferrer"
        className={`border-1 rounded-4 flex items-center justify-center px-16 py-12 transition-colors cursor-pointer w-fit bg-basic-white ${
          isDomainJournal
            ? 'border-basic-black hover:bg-basic-gray8'
            : 'border-dark-blue-dark-blue2 hover:bg-blueish-blueish4'
        }`}
      >
        <Typography variant="body3" component="span" color={textColor}>
          {translate('T_JOURNAL_SUBMIT_MANUSCRIPT')}
        </Typography>
      </Link>
    </div>
  )
}

export default EditorialPanelEntryButtons
